module.exports = "/images/2.png?706875b11b50b82bf71c440c977a3622";